.root {
	margin-block: var(--mantine-spacing-xl);
	background: var(--docs-card);
}

// The tabs and the full-screen controls sit on the card, above the page itself.
.bar {
	padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
	gap: var(--mantine-spacing-md);
}

.actions {
	flex-shrink: 0;
}

.hint {
	padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
}

// The demo draws its own dark background, so the frame has no border of its
// own. On a narrow screen it keeps most of the viewport rather than a fixed
// height, since the demos lay themselves out for the space they are given.
.frame {
	display: block;
	width: 100%;
	height: min(var(--demo-height), 78vh);
	border: 0;
	background: #14110d;
}

// Full screen covers the whole card, so the tabs stay at the top and the demo
// takes the rest of the screen.
.root:fullscreen {
	display: flex;
	flex-direction: column;
	margin: 0;

	.frame {
		flex: 1;
		height: auto;
	}
}
